import React from 'react'
import { formatCallDuration } from 'shared/lib'
import { Typography } from 'shared/ui'
import { EmptyCell } from 'shared/ui/Table'

type ICellDurationProps = {
  duration: number
}
const CellDuration: React.FC<ICellDurationProps> = ({ duration }) => {
  return (
    <>
      {Boolean(duration) ? (
        <Typography variant={'body-md-regular'} color={'tertiary'} ariaLabel={'label'} ellipsis>
          {formatCallDuration(duration)}
        </Typography>
      ) : (
        <EmptyCell />
      )}
    </>
  )
}

export { CellDuration }
